import { useEffect, useState } from 'react';
import {
  getPushState,
  subscribeToPush,
  unsubscribeFromPush,
  sendTestPush,
  type PushState,
} from '../lib/push';
import { apiErrorMessage } from '../api/client';
import { useToast } from '../contexts/ToastContext';

export default function NotificationsPage() {
  const toast = useToast();
  const [state, setState] = useState<PushState | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushState().then(setState);
  }, []);

  async function action(fn: () => Promise<PushState | number>, okText: string) {
    setBusy(true);
    try {
      await fn();
      setState(await getPushState());
      toast.success(okText);
    } catch (err: any) {
      toast.error(apiErrorMessage(err, 'Falha'));
    } finally {
      setBusy(false);
    }
  }

  async function test() {
    setBusy(true);
    try {
      const delivered = await sendTestPush();
      if (delivered > 0) {
        toast.success(`Notificação enviada para ${delivered} dispositivo(s).`);
      } else {
        toast.error('Nenhum dispositivo recebeu (inscreva-se ou cheque VAPID no servidor).');
      }
    } catch (err: any) {
      toast.error(apiErrorMessage(err, 'Falha no teste'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Notificações</h2>

      <div className="card space-y-3">
        <h3 className="font-semibold">Push neste dispositivo</h3>

        {state === 'unsupported' && (
          <p className="text-sm text-amber-700">
            Este navegador não suporta push. No iPhone, instale o app na tela inicial primeiro.
          </p>
        )}
        {state === 'denied' && (
          <p className="text-sm text-amber-700">
            Permissão de notificações negada. Habilite nas configurações do navegador para este site.
          </p>
        )}
        {state === 'subscribed' && (
          <p className="text-sm text-emerald-700">✓ Este dispositivo está inscrito.</p>
        )}
        {state === 'unsubscribed' && (
          <p className="text-sm text-slate-600">Este dispositivo não está inscrito.</p>
        )}

        <div className="flex flex-wrap gap-2">
          {state !== 'subscribed' && (
            <button
              className="btn btn-primary text-sm"
              disabled={busy || state === 'unsupported' || state === 'denied'}
              onClick={() => action(subscribeToPush, 'Inscrito com sucesso.')}
            >
              Ativar notificações
            </button>
          )}
          {state === 'subscribed' && (
            <>
              <button className="btn btn-secondary text-sm" disabled={busy} onClick={test}>
                Enviar teste
              </button>
              <button
                className="btn btn-secondary text-sm"
                disabled={busy}
                onClick={() => action(unsubscribeFromPush, 'Inscrição cancelada.')}
              >
                Desativar
              </button>
            </>
          )}
        </div>
      </div>

      <div className="card text-sm text-slate-600 space-y-1">
        <h3 className="font-semibold text-slate-800">Como funciona</h3>
        <p>
          Cada regra tem seus próprios gatilhos de notificação (erro, sucesso, email casou), ajustáveis
          na tela de <strong>Regras</strong>. Aqui você só liga/desliga o push neste aparelho.
        </p>
      </div>
    </div>
  );
}
